import React from 'react';

import amplitude from 'amplitude-js';
import { CountryItemPanel } from 'apps/auth/components/common/components/CountryItemPanel/CountryItemPanel';
import { ACCOUNT_CHANGED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { CARD_TYPE, FROM, TO } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { cardType } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { AUTH_GA_CARD } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const CountryPanelForAccount = (props) => {
    const { messagesCardRelinked } = usePageMessages();
    const { card = {} } = useExtra();
    const account = props.account;

    const nowLinked = card.cardPocket.id === account.id;
    const code = account.pocketCurrency.code;

    return (
        <CountryItemPanel
            onClick={(e) => {
                if (nowLinked) {
                    props.popupRef.current.close();
                } else {
                    amplitude.getInstance().logEvent(ACCOUNT_CHANGED, {
                        [CARD_TYPE]: card.virtual ? cardType.VIRTUAL : cardType.PLASTIC,
                        [FROM]: card.cardPocket.currency.code,
                        [TO]: code,
                    });
                    props.doRequest(e, `${AUTH_GA_CARD}${card.id}/link/account/${account.id}`, messagesCardRelinked);
                }
            }}
            flagIconName={code.toLowerCase()}
            isSelectedCountry={nowLinked}
            countryName={code.toUpperCase()}
            countryCurrency={account.balance + ' ' + code.toLowerCase()}
            getCurrencyIcon={props.getCurrencyIcon}
            onError={props.onError}
        />
    );
};
export default CountryPanelForAccount;
